module.exports = __webpack_public_path__ + "static/img/Sugih Gumilar-close.9eb2876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Sugih Gumilar-close.jpg
// module id = pLLY
// module chunks = 1